import React from 'react'
import "./Comprehensive_Service.css"
import { Container, Row, Col } from 'react-bootstrap'
import Common_Service_Card from '../../common_component/common-service-card/Common_Service_Card'

const Comprehensive_Service = () => {
  const servicesData = [
    {
      title: "Book a Ride",
      image: "/assets/images/common-service-card/taxi.png",
      title2: "Need to get somewhere quickly & safely?",
      subtitle: "Our dependable service offers on-demand or scheduled rides with professional drivers, ensuring you arrive relaxed and on time."
    },
    {
      title: "Easy Transport",
      image: "/assets/images/common-service-card/truck.png",
      title2: "Relocation a headache?",
      subtitle: "Our dedicated team treats your belongings like our own, providing expert packing, careful handling, & timely delivery for a swift move.",
    },
    {
      title: "Share Taxi & Bus",
      image: "/assets/images/common-service-card/bus.png",
      title2: "Want to Earn on the go?",
      subtitle: "Travel & Earn smarter. Share Taxi connects you with like-minded travelers heading the same way, as a cost-effective & efficient urban transit solution.",
    }
  ];

  return (
    <section className='comprehensive-section py-3'>
      <div className='container'>
        <Row>
          <Col>
            <div className='service_title'>
              <h2 className='title'>Comprehensive Service, <span>Simplified </span></h2>
              <p className='service_text'>
                We understand that life involves both moving
                between places and moving things. That’s why we've unified
                three critical services under one reliable roof:
              </p>
            </div>

            <Row className='g-4'>
              {servicesData.map((service, index) => (
                <Col lg={4} md={6} sm={6} xs={12} key={index}>
                  <Common_Service_Card
                    title={service.title}
                    image={service.image}
                    title2={service.title2}
                    subtitle={service.subtitle}
                  />
                </Col>
              ))}
            </Row>

          </Col>
        </Row>
      </div>
    </section>
  );
}

export default Comprehensive_Service
